import styled from 'styled-components';

import { LandingHero } from 'constants/landing-hero';

const MOBILE = '@media (max-width: 960px)';

export const Wrap = styled.div`
  padding: 9.6rem 7.2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 7.2rem;
  align-items: start;

  ${MOBILE} {
    padding: 5.6rem 2.4rem;
    grid-template-columns: 1fr;
    gap: 3.2rem;
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  gap: 2rem;
  padding: 2.4rem 0;
  border-bottom: 0.1rem solid ${LandingHero.band.border};

  &:last-child {
    border-bottom: none;
  }
`;

export const Check = styled.div`
  font-size: 1.8rem;
  font-weight: 900;
  color: ${LandingHero.pro.kicker};
  flex-shrink: 0;
`;

export const RowBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const RowTitle = styled.div`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${LandingHero.textPrimary};
`;

export const RowDescription = styled.div`
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${LandingHero.textMuted};
`;
